import React, { Component } from 'react'

import { translate } from 'react-i18next'
import { compose } from 'react-apollo'

class Loading extends Component {
  render() {
    const { t } = this.props

    return <div>{t('loading')}...</div>
  }
}

export default compose(translate('main'))(Loading)



// WEBPACK FOOTER //
// src/components/UI/Loading.jsx